import type { CSSProperties } from 'react'

export type BreadcrumbItem = {
  id?: string
  label: string
  href?: string
  onClick?: () => void
}

export type BreadcrumbRenderable =
  | { kind: 'item'; item: BreadcrumbItem; index: number }
  | { kind: 'ellipsis' }

export type BreadcrumbsProps = {
  items: BreadcrumbItem[]
  showBackIcon?: boolean
  onBackClick?: () => void
  /** Collapse middle segments when item count exceeds this value. */
  maxItems?: number
  /** Dark surface styling (aligned with other DS dark controls). */
  darkMode?: boolean
  className?: string
  style?: CSSProperties
}

export const BREADCRUMB_SHOWCASE_PRESETS = [
  'default',
  'multiple',
  'long',
] as const

export type BreadcrumbShowcasePreset =
  (typeof BREADCRUMB_SHOWCASE_PRESETS)[number]

export const getBreadcrumbRenderables = (
  items: BreadcrumbItem[],
  maxItems?: number,
): BreadcrumbRenderable[] => {
  if (!maxItems || items.length <= maxItems) {
    return items.map((item, index) => ({ kind: 'item', item, index }))
  }

  return [
    { kind: 'item', item: items[0], index: 0 },
    { kind: 'ellipsis' },
    {
      kind: 'item',
      item: items[items.length - 1],
      index: items.length - 1,
    },
  ]
}

export const buildBreadcrumbPresetItems = (
  preset: BreadcrumbShowcasePreset,
): BreadcrumbItem[] => {
  switch (preset) {
    case 'default':
      return [{ label: 'Item 1' }, { label: 'Item 2' }]
    case 'multiple':
      return [{ label: 'Item 1' }, { label: 'Item 2' }, { label: 'Item 3' }]
    case 'long':
      return Array.from({ length: 10 }, (_, index) => ({
        id: `item-${index + 1}`,
        label: index === 9 ? 'Item10' : `Item ${index + 1}`,
      }))
    default:
      return [{ label: 'Item 1' }, { label: 'Item 2' }]
  }
}
